import { render, staticRenderFns } from "./mRoleSelector.vue?vue&type=template&id=4b453425&scoped=true"
import script from "./mRoleSelector.vue?vue&type=script&lang=ts"
export * from "./mRoleSelector.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./mRoleSelector.vue?vue&type=style&index=1&id=4b453425&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b453425",
  null
  
)

export default component.exports